import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.16602 5.39409C1.16602 8.23084 3.51102 9.74226 5.22718 11.0956C5.83268 11.5728 6.41602 12.0225 6.99935 12.0225C7.58268 12.0225 8.16602 11.5733 8.77152 11.095C10.4883 9.74284 12.8327 8.23084 12.8327 5.39468C12.8327 2.55793 9.62435 0.546011 6.99935 3.27368C4.37435 0.545428 1.16602 2.55734 1.16602 5.39409Z"
        fill="#637381"
      />
    </svg>
  )
}

export default SvgComponent
